import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class StateManagementService {
    isCandidateFormAllowed: boolean = false;
    isTestRouteAllowed: boolean = false;
    isSubmitTestRouteAllowed: boolean = false;
}
